export default "__VITE_ASSET__qpYCgHES__"